import { render, staticRenderFns } from "./PartInventory.vue?vue&type=template&id=4b2ade88&scoped=true&"
import script from "./PartInventory.vue?vue&type=script&lang=js&"
export * from "./PartInventory.vue?vue&type=script&lang=js&"
import style0 from "./PartInventory.vue?vue&type=style&index=0&id=4b2ade88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2ade88",
  null
  
)

export default component.exports